import axios from "@/plugins/axios.js"
import api from "@/api.js"

export function normalizeListResponse(response, seen = new Set()){
	if (!response || seen.has(response)) return [];
	if (Array.isArray(response)) return response;
	if (typeof response !== 'object') return [];

	seen.add(response);

	const collectionKeys = ['rows', 'results', 'items', 'lists', 'list'];
	for (const key of collectionKeys) {
		if (Array.isArray(response[key])) return response[key];
		const nested = normalizeListResponse(response[key], seen);
		if (nested.length) return nested;
	}

	return normalizeListResponse(response.data, seen);
}

export function getListPageCount(response){
	const data = response && response.data ? response.data : response;
	if (!data || typeof data !== 'object') return 1;
	return parseInt(data.pages || data.totalPages || data.pageCount || 1);
}

export default new class ListDetails{
	constructor(){
		this.listDetails = [];
	}
	getListDetails(){
		return this.listDetails;
	}
	async getList(pg=1){
		try{
			if (api) {				
				const uri = `${api.url}/api/v1/list/?page=${pg}`;					
				const data = await axios.get(uri);							
				return data;
			}
		}catch(er){
			console.warn("Error get TechnicalService ", er)
			return er;
		}
		return null;
	}
	async getAllLists(){
		if (api) {
			const uri = `${api.url}/api/v1/list/all`;
			return axios.get(uri);
		}
		return null;
	}
	async createList({ name, type = 'face' } = {}){
		return axios.post(`${api.url}/api/v1/list`, { name, type })
	}
	async addListMembers({ listId, entity = [], motive = 'Added from roster', type = 'face' } = {}){
		return axios.post(`${api.url}/api/v1/listing_details/`, { listId, entity, motive, type })
	}
	async findListMembers({ type = 'face', where = {}, page = 1, exportAll = true, limit = 10000 } = {}){
		return axios.post(`${api.url}/api/v1/listing_details/find/?page=${page}`, {
			type,
			where,
			export_all: exportAll,
			limit,
		})
	}
	async removeListMember(id){
		return axios.delete(`${api.url}/api/v1/listing_details/${id}/`)
	}
	async getListFor(pg=1){		
		try{
			this.listDetails = [];
			try{
				const allRes = await this.getAllLists();
				const allRows = normalizeListResponse(allRes);
				if (allRows.length > 0) {
					this.listDetails = allRows;
					return this.listDetails;
				}
			}catch(_er){
				// Fallback to the paginated endpoint used by existing callers.
			}
			let isLoadingReq = true;
			while(isLoadingReq){
				const res =  await this.getList(pg);
				const rows = normalizeListResponse(res);
				if (rows.length > 0) {
					this.listDetails 		= this.listDetails.concat(rows);// temp_list;
				}		
				if (getListPageCount(res) > pg) {
					pg++;					
				}else{
					isLoadingReq = false;
					return this.listDetails;
				}
			}			
		}catch(er){
			console.warn("Error get ListDetailsService ", er)
			return er;
		}
		
	}
}
